import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { GET_CATALOG_RESOURCE_MIGRATION_LOG_QUERY } from '../../__generated__/chirp/com/hubspot/academy/catalog/rpc/MigrationChirpService.dfc.new';
export const useSingleLanguageRedirect = ({
  contentId,
  language,
  contentType
}) => {
  const baseUrl = contentType === 'COURSE' ? '/tracks' : '/lessons';
  const {
    data,
    loading,
    error
  } = useQuery(GET_CATALOG_RESOURCE_MIGRATION_LOG_QUERY, {
    variables: {
      oldEntityId: contentId,
      entityType: contentType
    },
    skip: !contentId
  });
  const redirectUrl = useMemo(() => {
    var _data$result;
    const value = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.value;
    if (!(value !== null && value !== void 0 && value.newIdToLanguageMappings)) {
      return null;
    }
    if ((value === null || value === void 0 ? void 0 : value.status) !== 'COMPLETED') {
      return null;
    }
    const newIdForCurrentLanguage = Object.keys(value.newIdToLanguageMappings).find(newId => value.newIdToLanguageMappings[newId] === language.toUpperCase());
    if (!newIdForCurrentLanguage) {
      return null;
    }
    return `${baseUrl}/${newIdForCurrentLanguage}`;
  }, [data, language, baseUrl]);
  return {
    redirectUrl,
    loading,
    error
  };
};